








import { defineComponent } from "@vue/composition-api";
import LayoutDefault from "../layouts/LayoutDefault.vue";

export default defineComponent({
  name: "Unauthorized",
  components: {
    LayoutDefault,
  },
});
